/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const Process = () => {
  return (
    <Box>
      <Typography
        sx={{
          textTransform: 'uppercase',
          fontWeight: 'medium',
        }}
        gutterBottom
        color={'secondary'}
        align={'center'}
      >
        
      </Typography>
      <Typography fontWeight={800} variant={'h4'} gutterBottom align={'center'}>
        OVERVIEW
      </Typography>
      <Typography
        component={'p'}
        color={'text.secondary'}
        align={'justify'}
      >
        NPS Yeshwanthpur is a leading educational institution committed to provide a holistic education and is a forerunner in setting the highest academic standards. NPS YPR is dedicated to the overall personality development of our students by honing their leadership skills and looking after their emotional well-being.
The school is an integrated community of parents, teachers and children from all over the country. We at NPS strongly believe that the environment is the best educator. With a supporting environment, which involves both family and the institution we strive to develop in all learners the strong values, emotional wellbeing and crucial 21 century skills such as creativity, critical thinking, communication, collaboration, self-direction and self-management. This will empower them to become global citizens in this ever changing world.
Our teaching methodology enables our students to do well for themselves and do good for our world in a manner that authentically reflects the very best in each of them by inculcating a positive attitude and inquiry-based learning.

      </Typography>
      <Box marginTop={3} display={'flex'} justifyContent={'center'}>
        
      </Box>
    </Box>
    
  );
};

export default Process;
